import { SyncStatus } from "../../../Resources/Constants";
import { SyncDomainStatus } from "../../sync/SyncDomainController";
import {
  NutritionEntitySaveMode,
  NutritionEntitySyncStatus,
} from "./OptimisticNutritionEntity";

export function hasPendingDebouncedNutritionSync(entity) {
  return (
    entity?.saveMode === NutritionEntitySaveMode.DEBOUNCED &&
    entity?.syncStatus === NutritionEntitySyncStatus.DIRTY &&
    entity?.timerId != null
  );
}

export function resolveNutritionDomainStatus({
  controllerStatus = SyncDomainStatus.OK,
  entities = [],
} = {}) {
  const trackedEntities = Array.isArray(entities) ? entities.filter(Boolean) : [];

  if (
    controllerStatus === SyncDomainStatus.ERROR ||
    trackedEntities.some(
      (entity) => entity?.syncStatus === NutritionEntitySyncStatus.ERROR,
    )
  ) {
    return SyncDomainStatus.ERROR;
  }

  if (controllerStatus === SyncDomainStatus.ATTENTION) {
    return SyncDomainStatus.ATTENTION;
  }

  if (
    controllerStatus === SyncDomainStatus.OFFLINE_PENDING ||
    trackedEntities.some(
      (entity) =>
        entity?.syncStatus === NutritionEntitySyncStatus.OFFLINE_PENDING,
    )
  ) {
    return SyncDomainStatus.OFFLINE_PENDING;
  }

  if (
    controllerStatus === SyncDomainStatus.SYNCING ||
    trackedEntities.some(
      (entity) =>
        entity?.syncStatus === NutritionEntitySyncStatus.SAVING ||
        hasPendingDebouncedNutritionSync(entity),
    )
  ) {
    return SyncDomainStatus.SYNCING;
  }

  return SyncDomainStatus.OK;
}

export function mapNutritionDomainStatusToLegacySyncStatus(status) {
  switch (status) {
    case SyncDomainStatus.SYNCING:
    case SyncDomainStatus.OFFLINE_PENDING:
      return SyncStatus.WAITING;

    case SyncDomainStatus.ATTENTION:
    case SyncDomainStatus.ERROR:
      return SyncStatus.ERROR;

    case SyncDomainStatus.OK:
    default:
      return SyncStatus.SYNCED;
  }
}
